import script from "./MessageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageList.vue?vue&type=script&setup=true&lang=ts"

import "../mypage.css?vue&type=style&index=0&id=80de18e8&scoped=true&lang=css"
import "./MessageList.vue?vue&type=style&index=1&id=80de18e8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80de18e8"]])

export default __exports__